import React from 'react';
import WrapperInputGroup from "./WrapperInputGroup";
import PropTypes from "prop-types";

class TextArea extends React.Component {
    constructor(props) {
        super(props);
        props.input.value = props.input.value || "";
    }

    render() {
        return (
            <textarea autoFocus={this.props.autoFocus} onFocus={this.props.onFocus} value={this.props.input.value} name={this.props.input.name} id={this.props.input.id}
                      cols={this.props.input.cols} rows={this.props.input.rows} onChange={this.props.onChange} onBlur={this.props.onBlur}></textarea>
        )
    }
}

export const TextAreaGroup = WrapperInputGroup(TextArea);

TextAreaGroup.propTypes = {
    input: PropTypes.shape({
        id: PropTypes.string.isRequired,
        value: PropTypes.string,
        name: PropTypes.string.isRequired,
        rows: PropTypes.string.isRequired,
        cols: PropTypes.string.isRequired
    }).isRequired,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func
};


// WEBPACK FOOTER //
// ./src/input/base/TextAreaGroup.js